import { cases } from '@/mocks/cases';
import CaseCard from '@/components/feature/CaseCard';
import SectionHeading from './SectionHeading';

export default function HotCases() {
  const hot = cases.slice(0, 6);
  return (
    <section className="py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Trending Cases"
          title="本周热门爆料"
          desc="综合阅读量、材料完整度与当事方回应进度排序，优先展示证据链更完整的事件。"
          actionText="浏览全部爆料"
          actionTo="/cases"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {hot.map((item) => (
            <CaseCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}